import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEDropdown from '../../elements/controls/oe-dropdown';
import {OEGroupControl, OEControl, OEToggleCheckboxControl} from '../../elements/controls/oe-controls';
import retardUpdate from '../../../lib/react/update-retarder';

export default class OEVPGizmoControllerControlPanel extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.alignments = [];
        this.activeAlignmentId = -1;

        this.state = {
            uiEnabled: false,
            enabled: false,
            strings: {
                enable: '',
                alignment: ''
            },
            alignments: [],
            activeAlignmentId: this.activeAlignmentId
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onEnabledStateChanged = this.onEnabledStateChanged.bind(this);
        this.onActiveAlignmentChanged = this.onActiveAlignmentChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onEnableSwitchChanged = this.onEnableSwitchChanged.bind(this);
        this.onAlignmentSelected = this.onAlignmentSelected.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.vpGizmoEnabledChanged, this.onEnabledStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.vpGizmoActiveAlignmentChanged, this.onActiveAlignmentChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.vpGizmoEnabledChanged, this.onEnabledStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.vpGizmoActiveAlignmentChanged, this.onActiveAlignmentChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateAlignments()  {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;

        this.alignments = si.getUIControllerVPGizmo().getAlignments();

        this.updateAlignmentsState();
    }

    updateAlignmentsState()  {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;

        let alignments = this.alignments.map(alignment => {
            return {
                id: alignment.id,
                label: alignment.labelId ? si.getLocalizedStringEnc(alignment.labelId) : alignment.label,
            };
        });

        this.setState({alignments: alignments});
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;

        retardUpdate(this, () => {
            this.setState({
                strings: {
                    enable: si.getLocalizedStringEnc('vp_gizmo_view_enable'),
                    alignment: si.getLocalizedStringEnc('vp_gizmo_view_alignment')
                }
            });

            this.updateAlignmentsState();
        });
    }

    updateControlsState()   {
        if(!this.oe.isReady())  return;

        let controller = this.oe.sharedInterface.getUIControllerVPGizmo();

        this.activeAlignmentId = controller.getActiveAlignmentID();

        this.setState({
            enabled: controller.getEnabled(),
            activeAlignmentId: this.activeAlignmentId
        });
    }

    updateUIState()   {
        if(!this.oe.isReady())  return;

        this.setState({
            uiEnabled: this.oe.sharedInterface.getUIControllerVPGizmo().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({
                uiEnabled: false
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateAlignments();
            this.updateControlsState();
            this.updateUIState();
        });
    }

    onEnabledStateChanged() {
        this.updateControlsState();
    }

    onActiveAlignmentChanged() {
        this.updateControlsState();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.vp_gizmo) {
            this.updateUIState();
        }
    }

    renderAlignmentControl()    {
        let selectedAlignment = this.state.alignments.find(alignment => alignment.id === this.state.activeAlignmentId);
        let alignmentEntries = this.state.alignments.map(alignment => { return {key: alignment.id, content: <span className="label">{alignment.label}</span>} } );

        return (
            <OEControl title={this.state.strings.alignment} header={true}>
                <OEDropdown
                    title={selectedAlignment ? selectedAlignment.label : ''}
                    disabled={!(this.state.uiEnabled && !this.props.disabled)}
                    chosenKey={this.state.activeAlignmentId}
                    entries={alignmentEntries}
                    onClick={this.onAlignmentSelected}
                />
            </OEControl>
        );
    }

    renderControls()    {
        return (
            <React.Fragment>
                <OEToggleCheckboxControl
                    className="align-right"
                    title={this.state.strings.enable}
                    active={this.state.enabled}
                    disabled={!(this.state.uiEnabled && !this.props.disabled)}
                    onClick={this.onEnableSwitchChanged}
                />
                {this.props.alignmentControl ? this.renderAlignmentControl() : null}
            </React.Fragment>
        );
    }

    render()    {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                {this.renderControls()}
            </React.Fragment>
        );
    }

    onEnableSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerVPGizmo().setEnabled(!this.state.enabled);
    }

    onAlignmentSelected(id) {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerVPGizmo().setActiveAlignmentID(id);
    }
}

OEVPGizmoControllerControlPanel.defaultProps = {
    moduleId: '',
    disabled: false,
    alignmentControl: true
};

OEVPGizmoControllerControlPanel.propTypes = {
    moduleId: PropTypes.string,
    disabled: PropTypes.bool,
    alignmentControl: PropTypes.bool
};